import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { UseSpecialCategoryFilterValueFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseSpecialCategoryFilterValueFragmentFragmentDoc';

import type { SelectedFilterValue } from '../types';

/* GraphQL */ `
  fragment UseSpecialCategoryFilterValueFragment on SearchProductResult {
    ... on SuccessfulSearchResult {
      selectedCategory {
        id
      }
    }
  }
`;

export const SPECIAL_CATEGORY_FILTER_ID = 'SERP-special-category-filter';

export const useSpecialCategoryFilterValue = (
  maskedData: FragmentType<typeof UseSpecialCategoryFilterValueFragmentFragmentDoc>,
) => {
  const data = getFragmentData(UseSpecialCategoryFilterValueFragmentFragmentDoc, maskedData);

  return {
    selectedCategoryFilterValues:
      'selectedCategory' in data && data.selectedCategory
        ? [
            {
              filterId: SPECIAL_CATEGORY_FILTER_ID,
              selectedValues: [data.selectedCategory.id],
            } satisfies SelectedFilterValue,
          ]
        : [],
  };
};
